export default function BookBlankIcon({ className }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 640"
        className={className ? className : "w-5 h-5"}
      >
        <path d="M160 64C124.7 64 96 92.7 96 128L96 512L96 512C96 547.3 124.7 576 160 576L528 576C536.8 576 544 568.8 544 560C544 551.2 536.8 544 528 544L512 544L512 477.3C530.6 470.7 544 452.9 544 432L544 112C544 85.5 522.5 64 496 64L160 64zM480 480L480 544L160 544C142.3 544 128 529.7 128 512C128 494.3 142.3 480 160 480L480 480zM160 448C148.3 448 137.4 451.1 128 456.6L128 128C128 110.3 142.3 96 160 96L496 96C504.8 96 512 103.2 512 112L512 432C512 440.8 504.8 448 496 448L160 448z"/>
      </svg>
    );
  }
